/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import { Grid, Paper } from "@mui/material";
import { useParams } from "react-router-dom";
import React, { useRef, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo } from "react";
// component
import AuthService from "Lib/API/Auth";
import FormService from "Lib/API/Forms";
import { formSlice } from "services/api/forms";
import * as calculation from "helper/CalculateEvent";
import { checkIsStripe, checkIsTranzila } from "helper/checkIsStripe";
import { ContactUs } from "components/ContactUs/ContactUs";
// direct import
import OtpModal from "./OtpModal";
import Header from "./Header/Header";
import { calculateTotals } from "./helper";
import { validationSchema } from "./validation";
import RenewalDetails from "./RenewalDetails/summary";
import { PaymentCard } from "./PaymentCard/PaymentCard";
import { SummaryCard } from "./SummaryCard/SummaryCard";
import { PaymentResultPage } from "./PaymentResultPage/PaymentResultPage";
import { PersonalDetailsCard } from "./PersonalDetailsCard/PersonalDetailsCard";
import { getAuthenticated, getAccessTokenSilently } from "utils/functions";
import FinanceService from "Lib/API/Finance";
import DonationBox from "components/DonationBox/DonationBox";
import { Fonts, FontFamilies, FontWeights, FontColors } from "theme/fontConfig";

export const MembershipForm = () => {
  const recaptchaRef = useRef();

  const { id } = useParams();
  const dispatch = useDispatch();
  const addCardStripeRef = useRef(null);
  const isAuthenticated = getAuthenticated();
  const { enqueueSnackbar } = useSnackbar();
  // const postalLabel = postalCodeFormat();
  // use Selector
  const { logoImage } = useSelector((state) => state.organization);
  const { ticketTypeVariants } = useSelector((state) => state?.Events);
  const { formOnlineData, numberOfTickets, totalProducts } = useSelector(
    (state) => state?.Forms,
  );
  // storage value
  const token = localStorage.getItem("token");
  const isAuth =
    localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;
  const allowInstallmentsOrganization =
    localStorage.getItem("allowInstallments") === "true";
  const logo = isAuth ? logoImage : localStorage.getItem("logoImgForm");
  const paymentMethod = JSON.parse(
    localStorage.getItem("paymentMethodCreditCard"),
  );
  // state
  const [newProducts, setProducts] = useState([]);
  const [tempToken, setTempToken] = useState(null);
  const [verifyModal, setVerifyModal] = useState(true);
  const [isLoadingPay, setLoadingPay] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedAchCard, setSelectedAchCard] = useState(null);
  const [achPaymentMethod, setAchPaymentMethod] = useState(null);
  const [error, setError] = useState({ value: true, message: "" });
  const [checkoutDonationLedger, setCheckoutDonationLedger] = useState(null);
  const [donationAmount, setDonationAmount] = useState(0);
  const [donationError, setDonationError] = useState(false);
  const [isLoadingDonationLedger, setIsLoadingDonationLedger] = useState(true);

  // function start from here
  const handleTotalForPay = () => {
    const totalforAllTicketsAfterDiscount = calculation.calculateTotalPayment(
      formOnlineData,
      ticketTypeVariants,
      "type",
      isAuth,
    );

    return {
      total: (+totalforAllTicketsAfterDiscount + +totalProducts + +donationAmount).toFixed(2),
    };
  };
  const totalPay = handleTotalForPay();

  const generateToken = async () => {
    const subDomain = window.location.hostname.split(".")[0];
    const hostName = subDomain === "localhost" ? (process.env.REACT_APP_LOCAL_ORGKEY || "stagerms") : subDomain;
    try {
      const res = await AuthService.generateToken(hostName);
      localStorage.setItem("FormToken", res?.token);
      localStorage.setItem("FormOrgId", res?._id);
      localStorage.setItem("logoImgForm", res?.logoImg);
      localStorage.setItem("orgName", res?.orgName);
      localStorage.setItem("shul_website", res?.shul_website);
      document.title = `${res?.orgName}`;
      localStorage.setItem("getOrginasitionBySubDomain", JSON.stringify(res));
      localStorage.setItem(
        "allowBillMyAccountOnDonation",
        res?.allowBillMyAccountOnDonation || false,
      );
      localStorage.setItem("country", JSON.stringify(res?.country || {}));
      localStorage.setItem(
        "allowInstallments",
        res?.allowInstallments || false,
      );
      localStorage.setItem("orgHasPayment", res?.hasPayment || false);

      localStorage.setItem(
        "paymentMethodCreditCard",
        JSON.stringify(res?.paymentMethodCreditCard),
      );
      setAchPaymentMethod(res?.paymentMethodAch);
      localStorage.setItem(
        "paymentMethodAch",
        JSON.stringify(res?.paymentMethodAch),
      );
      localStorage.setItem(
        "memberSetting",
        JSON.stringify(res?.memberSetting || {}),
      );
      localStorage.setItem(
        "memberPortalDirectory",
        JSON.stringify(res?.memberPortalDirectory || false),
      );
      setTempToken(res);
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: "error",
      });
    }
  };


  const [convenienceFeeByPayment, setConvenienceFeeByPayment] = useState({
    "credit-card": true,
    ach: true,
  });

  useEffect(() => {
    dispatch(formSlice.actions.setFormOnlineData({}));
    generateToken();
    const fetchCheckoutDonationLedger = async () => {
      try {
        const orgToken = isAuth
          ? await getAccessTokenSilently()
          : localStorage.getItem("FormToken");
        const orgId = localStorage.getItem("FormOrgId");
        const res = await FinanceService.getCheckoutDonationLedger(orgToken, orgId);
        if (res?.ledger) setCheckoutDonationLedger(res.ledger);
      } catch (_) {} finally {
        setIsLoadingDonationLedger(false);
      }
    };
    fetchCheckoutDonationLedger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const enableCreditCardPay = paymentMethod?.allow_member || !isAuth;

  const enableAchPay =
    achPaymentMethod?.allow_member && checkIsStripe(achPaymentMethod);

  const disabledCreditCardPay =
    (!paymentMethod?.allowMemberInstallment && isAuth) || donationError;

  const displayAchTooltip = useMemo(
    () => (!enableAchPay ? "Please login to pay with ACH" : ""),
    [enableAchPay],
  );

  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {
      errors: [],
      selectedCard: null,
      selectedAchCard: null,
      dropdowns: [],
      accountInfo: {},
      cardsDetails: {
        zip: "",
      },
      resultPage: "",
      activePayment: "credit-card",
      formInfo: {},
      tokenForOneHour: "",
      renewalOptions: null,
      houseOptions: [],
      addonsOptions: [],
      billMyAccount: false,
      finantialAid: false,
      listAch: {},
      listCards: {},
      captchaValue: null,
      saveCard: false,
      isStripe: false,
      addCard: false,
    },
    validationSchema,
    onSubmit: async (values) => PayNow(values),
  });
  const activePayment = formik?.values?.activePayment;

  const enableBillMyAccount = formik.values?.formInfo?.allowBillMyAccount ?? true;

  const isInstallmentEnabled = useMemo(() => {
    if (activePayment === "bill-my-account") return false;
    if (!allowInstallmentsOrganization) {
      return false;
    }

    return isAuth
      ? paymentMethod?.allowMemberInstallment ||
      achPaymentMethod?.allowMemberInstallment
      : true;
  }, [allowInstallmentsOrganization, isAuth, paymentMethod, achPaymentMethod, activePayment]);

  useEffect(() => {
    formik.setFieldValue("selectedCard", selectedCard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCard]);

  useEffect(() => {
    formik.setFieldValue("selectedAchCard", selectedAchCard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAchCard]);

  const getSelectedPricesAsync = async (
    formInfo,
    renewalOptions,
    addonsOptions,
  ) => {
    let selectedPrices = [];
    if (renewalOptions) {
      const member = formInfo?.membershipPricing?.find(
        (el) => el?.amount === renewalOptions,
      );
      if (member) selectedPrices.push(member);
    }

    const validAddonsOptions = addonsOptions?.filter((id) => id?.trim() !== "");

    if (validAddonsOptions?.length > 0) {
      const addons = formInfo?.addOns?.filter((el) =>
        validAddonsOptions.includes(el?._id),
      );
      if (addons?.length > 0) selectedPrices.push(...addons);
    }

    return selectedPrices;
  };

  useEffect(() => {
    let isMounted = true;

    const updateFormPricing = async () => {
      const { formInfo, renewalOptions, addonsOptions } = formik?.values;

      const newArray = await getSelectedPricesAsync(
        formInfo,
        renewalOptions,
        addonsOptions,
      );

      const getInstalment = newArray?.map((el) => {
        const getInstalmentObj = formOnlineData?.formPricing?.prices?.find(
          (item) => item?._id === el?._id,
        );
        return {
          ...el,
          installment: getInstalmentObj?.installment ?? {},
          installmentStatus: getInstalmentObj?.installment ?? false,
        };
      });

      const totalAmount = newArray
        .reduce((sum, item) => sum + (item?.amount || 0), 0)
        .toFixed(2);

      // Preserve existing pricing fields
      const existingPricing = formOnlineData?.formPricing || {};

      const updatedFormDetails = {
        ...formOnlineData,
        formPricing: {
          ...existingPricing,
          totalAmount: parseFloat(totalAmount),
          prices: getInstalment,
        },
      };

      if (isMounted) {
        dispatch(formSlice.actions.setFormOnlineData(updatedFormDetails));
      }
    };

    updateFormPricing();

    return () => {
      isMounted = false;
    };
  }, [
    formik?.values?.formInfo,
    formik?.values?.renewalOptions,
    formik?.values?.addonsOptions,
    formOnlineData?.prices,
  ]);

  const totalAmountCalculation = calculation?.calculateDiscount(
    formOnlineData,
    numberOfTickets,
    "form",
    isAuth,
  );

  const totalDiscount = totalAmountCalculation?.totalDiscount;

  const getCurrentPaymentMethod = useCallback(() => {
    if (formik?.values?.activePayment === "credit-card") {
      return paymentMethod;
    }
    if (formik?.values?.activePayment === "ach") {
      return achPaymentMethod;
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMethod, achPaymentMethod, formik.values?.activePayment]);

  const currentPaymentMethod = useMemo(() => getCurrentPaymentMethod(), [
    getCurrentPaymentMethod,
  ]);

  const isStripe = useMemo(() => checkIsStripe(currentPaymentMethod), [
    currentPaymentMethod,
  ]);

  useEffect(() => {
    formik.setFieldValue("isStripe", isStripe);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStripe]);

  const makeFormScreen = totalPay?.total !== "0.00" || totalProducts > 0;

  // get stripe token
  const handleGetStripeToken = async () => {
    const tokenId = await addCardStripeRef?.current?.handleGetToken();
    if (tokenId && tokenId !== null && token !== undefined) {
      return tokenId;
    }
    return "";
  };

  // Api For Pay
  const PayNow = async (values) => {
    const captchaValue = recaptchaRef?.current?.getValue();
    if (!captchaValue)
      return enqueueSnackbar("Please verify the captcha", { variant: "error" });
    const tokenId = await handleGetStripeToken();

    if (isStripe && activePayment === "credit-card" && !values?.selectedCard && !tokenId) {
      return enqueueSnackbar("Please verify the card number", {
        variant: "error",
      });
    }

    const body = {
      formId: id,
      housingTags: values?.houseOptions,
      billingInfo: {
        first_name: values?.accountInfo?.first_name,
        last_name: values?.accountInfo?.last_name,
        primary_email_address: values?.accountInfo?.primary_email_address,
        zip: values?.cardsDetails?.zip,
      },
      coverFee: convenienceFeeByPayment[activePayment],
      accountAddresses: values?.accountInfo?.addresses?.map((el) => ({
        location: el?.location,
        city: el?.city,
        state: el?.state,
        zip_code: el?.zip_code,
        active: el?.active,
        billing: el?.billing,
        country: el?.country,
        neighborhood: el?.neighborhood,
        addressLine2: el?.addressLine2,
      })),
      charges: formOnlineData?.formPricing?.prices?.map((el) => ({
        id: el?._id,
        numberOfInstallment: el?.installment?.value ?? 0,
        ...((el?.openAmount || el?.type === "static" || el?.static === true) && { amount: el?.amount }),
      })),
      ...(values?.saveCard && { saveCard: values?.saveCard }),
      familyMembers: values?.accountInfo?.family_members?.map((el) => ({
        isNew: el?.isNew ?? false,
        ...(!el?.isNew && { _id: el?._id }),
        ...(el?.date_of_birth && { date_of_birth: el?.date_of_birth }),
        ...(el?.mobile_number && { mobile_number: el?.mobile_number }),
        ...(el?.home_phone && { home_phone: el?.home_phone }),
        ...(el?.email_address && { email_address: el?.email_address }),
        ...(el?.anniversary_date && { anniversary_date: el?.anniversary_date }),
        ...(el?.first_name && { first_name: el?.first_name }),
        ...(el?.last_name && { last_name: el?.last_name }),
      })),
      ...(!values?.billMyAccount && !values?.finantialAid && tokenId && { token: tokenId }),
      ...(!values?.billMyAccount &&
        !values?.finantialAid &&
        !tokenId &&
        !isStripe &&
        !selectedCard && {
        cardsDetails: {
          number: values?.cardsDetails?.card_number,
          exp_month:
            values?.cardsDetails?.expiry?.split("/")[0] ??
            values?.cardsDetails?.expMonth,
          exp_year:
            values?.cardsDetails?.expiry?.split("/")[1] ??
            values?.cardsDetails?.expYear,
          cvc: values?.cardsDetails?.cvc,
        },
      }),
      ...(selectedCard && { cardId: selectedCard }),
      ...(values?.selectedAchCard && { cardId: values?.selectedAchCard }),
      billMyAccount: values?.billMyAccount,
      finantialAid: values?.finantialAid,
      ...(!values?.billMyAccount && !values?.finantialAid && { paymentMethodId: currentPaymentMethod?._id }),
      ...(donationAmount > 0 && checkoutDonationLedger && {
        checkoutDonation: {
          ledger_id: checkoutDonationLedger._id || checkoutDonationLedger.ledger_id,
          ledger_name: checkoutDonationLedger.ledger_name,
          amount: donationAmount,
          account_receivable: checkoutDonationLedger.account_receivable,
        },
      }),
    };

    try {
      await FormService.submitMembership(token, body);
      formik.setFieldValue("resultPage", "success");
    } catch (err) {
      enqueueSnackbar(err?.data?.message, { variant: "error" });
    }
  };

  const setActivePaymentAfter = useCallback(() => {
    if (!isAuth) return formik.setFieldValue("activePayment", "credit-card");
    const activePayment = formik.values?.activePayment;
    if (
      paymentMethod?.allowMemberInstallment &&
      achPaymentMethod?.allowMemberInstallment
    ) {
      if (activePayment === "bill-my-account") {
        formik.setFieldValue("activePayment", "credit-card");
      }
      return;
    }

    const nextPayment = paymentMethod?.allowMemberInstallment
      ? "credit-card"
      : achPaymentMethod?.allowMemberInstallment
        ? "ach"
        : null;

    if (nextPayment) {
      formik.setFieldValue("activePayment", nextPayment);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMethod, achPaymentMethod, formik.values?.activePayment]);

  const onHandleSubmit = (data) => {
    const lastYearForCalculation = data?.formInfo?.lastYearForCalculation;
    const mappedPricing = data?.formInfo?.membershipPricing?.map((el) => {
      // Static records use their amount directly, ignoring last year's calculation
      if (el.type === "static" || el.static === true) {
        return { ...el, amount: el?.addAmount ?? el?.amount };
      }

      const isPercentage = el.amountType === "%";
      const addedAmount =
        isPercentage && lastYearForCalculation
          ? (lastYearForCalculation * el?.addAmount) / 100
          : el?.addAmount;

      const total = lastYearForCalculation
        ? lastYearForCalculation + addedAmount
        : addedAmount;

      return {
        ...el,
        amount: lastYearForCalculation ? total : el?.amount,
      };
    });

    // Safely set the updated formInfo with calculated amounts
    formik.setFieldValue("formInfo", {
      ...data?.formInfo,
      membershipPricing: mappedPricing,
    });

    formik.setFieldValue("accountInfo", data?.accountInfo);
    formik.setFieldValue("tokenForOneHour", data?.tokenForOneHour);
    formik.setFieldValue("listAch", data?.listAch);
    formik.setFieldValue("listCards", data?.listCards);
    localStorage.setItem("token", data?.tokenForOneHour);
    if (data?.listCards?.data?.length > 0) {
      const cardSelected = data?.listCards?.data?.find((el) => el?.is_default)
        ?.id;
      const cardConfirmed = cardSelected ?? data?.listCards?.data?.[0]?.id;
      formik.setFieldValue("selectedCard", cardConfirmed);
      setSelectedCard(cardConfirmed);
    }
  };
  const paymentType = formik.values?.activePayment;

  const calculateAmount = useMemo(() => {
    const isBillMyAccount = paymentType === "bill-my-account";
    const dataForCalculation = isBillMyAccount
      ? {
          ...formOnlineData,
          formPricing: {
            ...formOnlineData?.formPricing,
            prices: formOnlineData?.formPricing?.prices?.map((p) => ({
              ...p,
              installment: null,
              installmentStatus: false,
            })),
          },
        }
      : formOnlineData;
    const result = calculateTotals(
      dataForCalculation,
      paymentType,
      convenienceFeeByPayment[activePayment],
    );
    return {
      ...result,
      finalAmount: result.finalAmount + donationAmount,
      totalWithConvenienceFee: result.totalWithConvenienceFee + donationAmount,
      dueWithConvenienceFee: result.dueWithConvenienceFee + donationAmount,
    };
  }, [
    formOnlineData,
    paymentType,
    currentPaymentMethod,
    convenienceFeeByPayment,
    activePayment,
    donationAmount,
  ]);

  return (
    <>
      {formik.values?.resultPage !== "" ? (
        <PaymentResultPage
          result={formik.values?.resultPage}
          formik={formik}
          isTherePayment={totalPay?.total !== "0.00" || totalProducts > 0}
          showThanksMsg={
            formik.values?.activePayment === "bill-my-account" || false
          }
        />
      ) : (
        <>
          <Grid container>
            <Grid item xs={12}>
              <Header Logo={logo} />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ p: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={7}>
                    <Paper
                      sx={{
                        borderRadius: "10px",
                        mb: 3,
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "#1A2027" : "#2555EF",
                      }}
                    >
                      <Box sx={{ p: 5 }}>
                        <Typography
                          variant="h1"
                          style={{
                            fontSize: Fonts.GeneralPageHeaderFont.fontSize,
                            fontWeight: Fonts.GeneralPageHeaderFont.fontWeight,
                            color: FontColors.White,
                            fontFamily: FontFamilies.General,
                          }}
                        >
                          {formik?.values?.accountInfo?.family_name}
                        </Typography>
                        <Typography
                          variant="h6"
                          style={{
                            color: FontColors.BlueBFDBFE,
                            mt: 0.5,
                            fontWeight: FontWeights.SemiBold,
                            fontFamily: FontFamilies.General,
                          }}
                        >
                          {formik?.values?.formInfo?.formName}
                        </Typography>
                      </Box>
                    </Paper>
                    <RenewalDetails
                      formik={formik}
                      setSelectedCard={setSelectedCard}
                      setSelectedAchCard={setSelectedAchCard}
                    />
                  </Grid>
                  <Grid item xs={12} lg={5}>
                    <SummaryCard
                      handleTotalForPay={handleTotalForPay}
                      newProducts={newProducts}
                      setProducts={setProducts}
                      totalDiscount={totalDiscount}
                      isInstallmentEnabled={isInstallmentEnabled}
                      setActivePaymentAfter={setActivePaymentAfter}
                      calculateAmount={calculateAmount}
                      activePayment={activePayment}
                      convenienceFeeByPayment={convenienceFeeByPayment}
                      setConvenienceFeeByPayment={setConvenienceFeeByPayment}
                      currentPaymentMethod={currentPaymentMethod}
                    />
                    <PersonalDetailsCard
                      formik={formik}
                      isLoadingPay={isLoadingPay}
                      PayNow={PayNow}
                      error={error}
                      setError={setError}
                      handleTotalForPay={handleTotalForPay}
                      totalProducts={totalProducts}
                      isTherePayment={makeFormScreen}
                      showZipCode={!isAuth}
                      isAuthenticated={isAuth}
                    />

                    {activePayment !== "bill-my-account" && (
                      <DonationBox
                        ledger={checkoutDonationLedger}
                        loading={isLoadingDonationLedger}
                        onDonationChange={(amount, ledger) => { setDonationAmount(amount); if (ledger) setCheckoutDonationLedger(ledger); }}
                        onErrorChange={setDonationError}
                      />
                    )}

                    <PaymentCard
                      TotalForPay={totalProducts}
                      formik={formik}
                      isLoadingPay={isLoadingPay}
                      totalPay={calculateAmount}
                      setLoadingPay={setLoadingPay}
                      isStripe={isStripe}
                      addCardStripeRef={addCardStripeRef}
                      isAuthenticated={isAuth}
                      setSelectedCard={setSelectedCard}
                      selectedCard={selectedCard}
                      recaptchaRef={recaptchaRef}
                      setSelectedAchCard={setSelectedAchCard}
                      selectedAchCard={selectedAchCard}
                      enableCreditCardPay={enableCreditCardPay}
                      enableAchPay={enableAchPay}
                      displayAchTooltip={displayAchTooltip}
                      disabledCreditCardPay={disabledCreditCardPay}
                      donationError={donationError}
                      publicKey={
                        currentPaymentMethod?.paymentGateway?.keys?.publicKey
                      }
                      enableBillMyAccount={enableBillMyAccount}
                      finantialAid={formik.values.finantialAid}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <ContactUs formOnlineData={formOnlineData} />
            </Grid>
          </Grid>
          <OtpModal
            open={verifyModal}
            handleClose={() => { }}
            setVerifyModal={setVerifyModal}
            onHandleSubmit={onHandleSubmit}
            tempToken={tempToken}
          />
        </>
      )}
    </>
  );
};
